import * as React from "react"

export default function GoKartIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.173 5.638c.547 0 1.042.324 1.26.826l1.027 2.36c.1.227.324.375.573.375h.769c.759 0 1.375.616 1.375 1.375v.287h.556l.992-2.533-.878-.878-.628.638a.375.375 0 01-.534-.526l1.787-1.813a.375.375 0 01.534.527l-.633.64.65.65.066-.166a.375.375 0 01.52-.196l5.402 2.78c.416.214.723.595.844 1.047l.029.109a1.38 1.38 0 01-1.332 1.732h-.57a2.36 2.36 0 01-4.386 0H6.313A2.575 2.575 0 011.4 11.785c0-1.252.893-2.295 2.078-2.528l-.594-1.415H1.662a.376.376 0 01-.365-.288l-.286-1.2a.376.376 0 01.431-.457l2.37.43a.376.376 0 01.31.368v.772a.376.376 0 01-.376.375h-.05l.582 1.385c.234.027.459.085.67.17l-.356-3.344a.377.377 0 01.373-.415h.208zm-1.195 4.32a1.827 1.827 0 100 3.654 1.827 1.827 0 000-3.654zm10.811.433a1.61 1.61 0 10.001 3.221 1.61 1.61 0 000-3.221zm-2.276-2.017l-.975 2.487h1.185a2.36 2.36 0 014.427 1.14c0 .04-.004.08-.006.121h.408a.629.629 0 00.606-.79l-.028-.107a.909.909 0 00-.462-.575l-5.033-2.59-.122.314zm-5.967 3.237c.004.058.009.116.009.174 0 .114-.01.227-.025.337h5.905c-.003-.04-.006-.08-.006-.121 0-.133.013-.263.034-.39H6.546zm-.79-1.686c.273.26.487.579.625.936h3.046v-.287a.625.625 0 00-.625-.625h-.769a1.375 1.375 0 01-1.26-.826l-1.028-2.36a.624.624 0 00-.36-.336l.372 3.498zM1.959 7.092h1.413v-.084l-1.498-.272.085.356z"
        fill={props.fill}
      />
    </svg>
  )
}
